import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'deviceLabelMap',
  pure: true
})
export class DeviceLabelMapPipe implements PipeTransform {
  DeviceMap = {
    roku: {
      label: 'Roku',
      withIcon:
        '<img class="mr-1" src="/assets/images/roku.png" alt="Roku Icon"/> Roku'
    },
    firetv: {
      label: 'Fire TV',
      withIcon:
        '<img class="mr-1" src="/assets/images/firetv.png" alt="Fire TV Icon"/> Fire TV'
    },
    samsung: {
      label: 'Samsung',
      withIcon:
        '<img class="mr-1" src="/assets/images/samsung.png" alt="Samsung Icon"/> Samsung'
    },
    tvos: {
      label: 'tvOS',
      withIcon:
        '<img class="mr-1" src="/assets/images/tvos.png" alt="tvOS Icon"/> tvOS'
    },
    lgtv: {
      label: 'LG TV',
      withIcon:
        '<img class="mr-1" src="/assets/images/lgtv.png" alt="LG TV Icon"/> LG TV'
    }
  };

  constructor() {}

  transform(device: string, includeIcon = false): string {
    const item = this.DeviceMap[device] || device;

    if (includeIcon) {
      return item.withIcon || device;
    }

    return item.label;
  }
}
